import React, { useEffect, useState } from "react";
import { Drawer, Box } from "@mui/material";
import AdminDrawerList from "../../components/AdminDrawerList";
import AdminRoutes from "../../../Routes/AdminRoutes";
import AdminNavbar from "../../components/AdminNavbar";
import { useAppDispatch } from "../../../State/Store";
import { fetchHomeCategories } from "../../../State/admin/adminSlice";

const AdminDashboard = () => {
  const dispatch = useAppDispatch();
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    dispatch(fetchHomeCategories());
  }, [dispatch]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      {/* Top Navigation Bar */}
      <AdminNavbar onMenuClick={handleDrawerToggle} />

      <div className="flex flex-1">
        {/* Desktop Permanent Drawer */}
        <section className="hidden lg:block w-64 border-r border-slate-200 bg-white min-h-[calc(100vh-64px)]">
          <AdminDrawerList />
        </section>

        {/* Mobile Temporary Slide-Over Drawer */}
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }} // Optimized mobile performance
          sx={{
            display: { xs: "block", lg: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: 260,
            },
          }}
        >
          <AdminDrawerList toggleDrawer={handleDrawerToggle} />
        </Drawer>

        {/* Main Route Content */}
        <main className="flex-1 p-4 sm:p-8 lg:p-10 overflow-y-auto max-w-7xl">
          <AdminRoutes />
        </main>
      </div>
    </div>
  );
};

export default AdminDashboard;